/**
 * The Self-Assessment section's own vocabulary, mapped onto the panel-wide
 * design tokens in component/common/designSystem/theme.js — the same split
 * moodTheme.js and vidsTheme.js use: only domain meaning lives here, palettes
 * belong to the design system.
 */
import { CHART_COLORS } from '../../../../component/common/designSystem';

/**
 * The four score quartiles, 0–24% → 75–100%.
 *
 * Deliberately a sequential light-to-dark ramp and NOT the green/amber/red the
 * Mood section uses. A high score is good on a resilience questionnaire and bad
 * on a burnout one, so colouring quartiles by valence would assert something
 * false about half the catalogue. The ramp says "a scale" and nothing more.
 */
export const SCORE_RAMP = [
  CHART_COLORS.brandSoft,
  CHART_COLORS.blue,
  CHART_COLORS.brand,
  CHART_COLORS.moss
];

/**
 * Secure / Avoidant / Anxious / Disorganised. Four categories rather than a
 * scale — an attachment style is a description, not a rank — so these are four
 * distinct hues instead of a ramp.
 */
export const ATTACHMENT_RAMP = [
  CHART_COLORS.teal,
  CHART_COLORS.brand,
  CHART_COLORS.orange,
  CHART_COLORS.pink
];

/**
 * How many assessments one person has finished. Coming back for a second one is
 * the engagement signal worth seeing, so this runs sparse → regular.
 */
export const VOLUME_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.brandSoft,
  CHART_COLORS.brand,
  CHART_COLORS.green
];

/**
 * Under 5 min → over an hour. Neutral again: a fast run can mean an easy
 * questionnaire or a rushed one, and a slow one usually just means the person
 * put it down and came back.
 */
export const DURATION_RAMP = [
  CHART_COLORS.teal,
  CHART_COLORS.blue,
  CHART_COLORS.brand,
  CHART_COLORS.moss
];

/** Finished / still open / abandoned, for the start-to-finish bar. */
export const FUNNEL_RAMP = [CHART_COLORS.green, CHART_COLORS.amber, CHART_COLORS.gray];
